var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 30,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 29,
    rx: 4.5,
    fill: "white",
    stroke: "#9876A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4633 16.1404C10.1665 16.3942 9.78869 16.5052 9.18453 16.5052H8.93383V13.4769H9.18453C9.78869 13.4769 10.152 13.5804 10.4633 13.8468C10.7846 14.1221 10.9777 14.5467 10.9777 14.986C10.9777 15.4273 10.7846 15.8671 10.4633 16.1404ZM9.37168 12.7012H8V17.2812H9.36332C10.0888 17.2812 10.6125 17.116 11.0715 16.7515C11.6168 16.3197 11.9403 15.6677 11.9403 14.9923C11.9403 13.6403 10.8848 12.7012 9.37168 12.7012Z",
    fill: "#201D1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3708 12.7012H13.301V17.2812H12.3708V12.7012Z",
    fill: "#201D1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5851 14.4567C15.0237 14.2596 14.8596 14.1284 14.8596 13.8808C14.8596 13.5931 15.1528 13.3749 15.5561 13.3749C15.8356 13.3749 16.0659 13.482 16.3112 13.7436L16.7968 13.134C16.3955 12.7961 15.9153 12.625 15.3918 12.625C14.5448 12.625 13.8992 13.1889 13.8992 13.9345C13.8992 14.5676 14.1993 14.8888 15.0751 15.1938C15.4412 15.3156 15.6273 15.3988 15.7215 15.4552C15.9081 15.5706 16.001 15.736 16.001 15.9271C16.001 16.2997 15.6925 16.5736 15.2755 16.5736C14.8315 16.5736 14.4723 16.3609 14.2573 15.9615L13.6555 16.5191C14.0857 17.1223 14.6014 17.3919 15.3119 17.3919C16.2809 17.3919 16.9636 16.7711 16.9636 15.887C16.9636 15.1584 16.647 14.8281 15.5851 14.4567Z",
    fill: "#201D1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2571 14.9923C17.2571 16.3392 18.3619 17.3829 19.7841 17.3829C20.1852 17.3829 20.529 17.3072 20.9523 17.116V16.0634C20.5782 16.4232 20.2498 16.5651 19.825 16.5651C18.8852 16.5651 18.2195 15.9144 18.2195 14.9859C18.2195 14.1087 18.9068 13.4137 19.7841 13.4137C20.2268 13.4137 20.565 13.5638 20.9523 13.9289V12.8776C20.5433 12.6796 20.2076 12.5977 19.8033 12.5977C18.3892 12.5977 17.2571 13.6618 17.2571 14.9923Z",
    fill: "#201D1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5145 15.776L27.2381 12.7012H26.2205L28.2495 17.3968H28.7499L30.8183 12.7012H29.8086L28.5145 15.776Z",
    fill: "#201D1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2417 17.2812H33.8886V16.5052H32.1755V15.2689H33.8236V14.493H32.1755V13.4769H33.8886V12.7012H31.2417V17.2812Z",
    fill: "#201D1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7117 14.8073H35.4408V13.422H35.727C36.3101 13.422 36.6225 13.6562 36.6225 14.1023C36.6225 14.5608 36.3101 14.8073 35.7117 14.8073ZM37.5837 14.0525C37.5837 13.1948 36.9689 12.7012 35.8912 12.7012H34.5049V17.2812H35.4408V15.4398H35.5621L36.8517 17.2812H38L36.4941 15.3509C37.1979 15.2132 37.5837 14.7533 37.5837 14.0525Z",
    fill: "#201D1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.352 15.003C26.352 16.3216 25.2355 17.3904 23.857 17.3904C22.4788 17.3904 21.3621 16.3216 21.3621 15.003C21.3621 13.6842 22.4788 12.6152 23.857 12.6152C25.2355 12.6152 26.352 13.6842 26.352 15.003Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.352 15.003C26.352 16.3216 25.2355 17.3904 23.857 17.3904C22.4788 17.3904 21.3621 16.3216 21.3621 15.003C21.3621 13.6842 22.4788 12.6152 23.857 12.6152C25.2355 12.6152 26.352 13.6842 26.352 15.003Z",
    fill: "url(#paint1_radial_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 22.3262,
    y1: 13.0664,
    x2: 25.4317,
    y2: 16.8164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA9D2C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4063 15.9961) rotate(-128.1) scale(3.27615 3.42355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA9D2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#DF7624",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760188,
    stopColor: "#BF4B23",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3017"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.c2b9cc2143ad306b002b03fa9824a486.svg";
export { ForwardRef as ReactComponent };